import { ORDER_META_KEY } from "../constants.js";
import GetMetaByOrderId from "../queries/GetMetaByOrderId.orders.js";
export const getCartIdByOrderId = async ({ orderId }, { client }) => {
    try {
        const data = await client.orders.request(GetMetaByOrderId, { orderId });
        if (!data?.orders?.get) {
            throw new Error(`No order found for orderId: ${orderId}`);
        }
        return data.orders.get.meta?.find(({ key }) => key === ORDER_META_KEY.CART_ID)?.value;
    }
    catch (err) {
        const graphQLErrors = err?.response?.errors ?? err?.graphQLErrors;
        const isGraphQLError = Array.isArray(graphQLErrors) && graphQLErrors.length > 0;
        const messages = isGraphQLError
            ? graphQLErrors.map((e) => e.message).join("; ")
            : (err?.message ?? "Unknown error");
        throw new Error(`getCartIdByOrderId failed: ${messages}`);
    }
};
